export enum IhmsGridStatus {
  New = 1,
  Assigned = 2,
  Returned = 3,
  SubmittedForReview = 4,
  Completed = 5,
}
